import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
import config from "../config";
import { message } from "antd";
import { getCached, setCached } from "./cacheStore";

class SpeedViolationReportStore {
  total = 0;
  loading = false;
  speedViolationStore = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,

      speedViolationStore: observable,
      loadData: action,
      sendExcelByEmail: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    offset,
    limit,
    toDate,
    fromDate,
    speedlimit,
    currentPage,
    allVehicleIds
  }) {

    // console.log("vehicle list");
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      speedlimit: speedlimit,
      offset: offset,
      limit: limit,
      page: currentPage,

    };

    const cacheKey = `speedviolationreportlist:${companyId}:${vehicleId}:${allVehicleIds}:${fromDate}:${toDate}:${speedlimit}:${offset}:${limit}`;
    const cached = getCached(cacheKey);
    if (cached) {
      this.total = cached.total;
      this.speedViolationStore = cached.reportData;
      return;
    }
    this.loading = true;
    var response
    if (config.pythonReport == 1) {
      response = await postApi.getClient('report').post("/alert_report/speed-violation", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=speedexception", "postData=" + base64Input);
    }
    const reportData = response?.data?.data?.speedexception ?? []
    const total = parseInt(response?.data?.data?.TotalCount)
    setCached(cacheKey, { total, reportData });

    this.total = total
    this.speedViolationStore = reportData
    this.loading = false;


    // console.log(response?.data?.data?.speedexception);
    // this.speedViolationStore = response?.data?.data?.speedexception;
    // this.total = parseInt(response?.data?.data?.TotalCount);
    // this.loading = false;
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport == 1) {




      try {
        await postApi.getClient("report").post("/alert_report/speed-violation/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }


      /*getData = { ...getData, language: "english", colList: getData.colList.replace(',view', '') }
      
      try {
          var response = await postApi.getClient("report").post("/alert_report/speed-violation/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Speed Violation Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }*/

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportspeedexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        // "&int=" +
        // getData.intervel +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&speedlimit=" +
        getData.speedlimit +
        "&colList=" +
        getData.colList;
    }
  }
  async exportpdf(getData) {

    if (config.pythonReport == 1) {


      try {
        await postApi.getClient("report").post("/alert_report/speed-violation/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
      /* getData = { ...getData, language: "english", colList: getData.colList.replace(',view', '') }
     
     try {
         var response = await postApi.getClient("report").post("/alert_report/speed-violation/download/pdf", getData, {
             responseType: "blob",
         });
     
         const blob = new Blob([response.data], {
             type: 'application/pdf'
         });
     
         const link = document.createElement("a");
         link.href = window.URL.createObjectURL(blob);
         link.download = "Speed Violation Report.pdf";
     
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
     } catch (error) {
         message.error("Failed to download the report. Please try again.")
     }*/

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportspeedpdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        // "&int=" +
        // getData.intervel +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&speedlimit=" +
        getData.speedlimit +
        "&colList=" +
        getData.colList;
    }
  }
  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportspeedcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.intervel +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&speedlimit=" +
      getData.speedlimit +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportspeedxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.intervel +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&speedlimit=" +
      getData.speedlimit +
      "&colList=" +
      getData.colList;
  }

  async sendExcelByEmail(data) {
    var postData = data;
    console.log(postData);
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=saveSpeedViolationDetails",
        "postData=" + base64Input
      );
    console.log(response);

    return response.data;
  }
}

export default SpeedViolationReportStore;
